import { createSlice } from "@reduxjs/toolkit";

const menuSlice = createSlice({
	name: "menu",
	initialState: {
		loadingMenu: false,
		error: null,
		selectedMenu: null,
	},
	reducers: {
		getMenu_(state, action) {
			return { ...state, loadingMenu: true };
		},

		setMenu_(state, action) {
			const menuData = action.payload;
			return {
				...state,
				loadingMenu: false,
				...menuData,
			};
		},
		getMenuFail_(state, action) {
			const error = action.payload;
			return { ...state, error: { ...error }, loadingMenu: false };
		},
		getSelectedMenu_(state, action) {
			return { ...state, loadingMenu: true };
		},
		setSelectedMenu_(state, action) {
			const menuData = action.payload;
			return {
				...state,
				selectedMenu: { ...menuData },
			};
		},
	},
});

export const {
	getMenu_,
	setMenu_,
	getMenuFail_,
	setSelectedMenu_,
	getSelectedMenu_,
} = menuSlice.actions;

export default menuSlice.reducer;
